export default "__VITE_ASSET__57516dc0__"